import { IconWrapper } from '../runtime';
export default IconWrapper('honey-one', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("rect", {
    "attrs": {
      "x": "4.92847",
      "y": "13.2239",
      "width": "11",
      "height": "5",
      "rx": "2",
      "transform": "rotate(-46.0247 4.92847 13.2239)",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }), h("rect", {
    "attrs": {
      "x": "19.3213",
      "y": "27.1108",
      "width": "11",
      "height": "5",
      "rx": "2",
      "transform": "rotate(-46.0247 19.3213 27.1108)",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }), h("rect", {
    "attrs": {
      "x": "6.4436",
      "y": "18.8546",
      "width": "17",
      "height": "5",
      "rx": "2",
      "transform": "rotate(-46.0247 6.4436 18.8546)",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }), h("rect", {
    "attrs": {
      "x": "13.6401",
      "y": "25.798",
      "width": "17",
      "height": "5",
      "rx": "2",
      "transform": "rotate(-46.0247 13.6401 25.798)",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }), h("rect", {
    "attrs": {
      "x": "7.2644",
      "y": "25.2048",
      "width": "25",
      "height": "5",
      "rx": "2",
      "transform": "rotate(-46.0247 7.2644 25.2048)",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }), h("path", {
    "attrs": {
      "d": "M25.0024 28.4237L29.1685 24.1058L43.5751 38.0061L39.409 42.3239L25.0024 28.4237Z",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M21 40.25C21 42.3211 19.2091 44 17 44C14.7909 44 13 42.3211 13 40.25C13 38.1789 17 34 17 34C17 34 21 38.1789 21 40.25Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin
    }
  })]);
});